import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

let descriptionNode;

export default function StepItem({ number, title, description }) {
  if (typeof description === 'string') {
    descriptionNode = (
      <Text
        color="primary"
        size="sm"
      >
        {description}
      </Text>
    );
  } else {
    descriptionNode = description;
  }
  return (
    <Stack
      direction="row"
      gap="16px"
    >
      <Box>
        <Stack
          alignItems="center"
          border="1px solid #1E1E1E"
          borderRadius="50%"
          gap="2px"
          height={{ xs: 30, md: 40 }}
          justifyContent="center"
          width={{ xs: 30, md: 40 }}
        >
          <Text
            align="center"
            size="xl"
            weight="medium"
          >
            {number}
          </Text>
        </Stack>
      </Box>

      <Stack flexGrow={1}>
        <Stack
          alignItems="center"
          direction="row"
          spacing="4px"
        >
          <Text
            color="primary"
            size="md"
            weight="medium"
          >
            {title}
          </Text>
        </Stack>
        {descriptionNode}
      </Stack>
    </Stack>
  );
}

StepItem.propTypes = {
  number: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};
